<template>
  <div>
    <mobile_AppHeader />
    <main>
      <slot></slot>
    </main>
    <mobile_AppFooter />
    <mobile_Tel />
    <mobile_BackTop />
  </div>
</template>

<script>
import mobile_AppHeader from "@/components/mobile_components/AppHeader/HeaderBar.vue";
import mobile_AppFooter from "@/components/mobile_components/AppFooter/Footer.vue";
import mobile_BackTop from "@/components/mobile_components/BackTop/BackTop.vue";
import mobile_Tel from "@/components/mobile_components/Tel/Tel.vue";

export default {
  name: "mobile_DefaultLayout",
  components: {
    mobile_AppHeader,
    mobile_AppFooter,
    mobile_BackTop,
    mobile_Tel,
  },
};
</script>

<style scoped>
/* 计算 main 区域的高度，减去 header 和 footer 的高度 */
main {
  min-height: calc(100vh - var(--header-height) - var(--footer-height));
}
</style>